export const allFoldersInArchive = "odb";
export const allFoldersString = "pdb";
export default {allFoldersInArchive,allFoldersString};